export default __webpack_public_path__ + "static/icon-36ce44db230c64cb10fee2557d8fd3dd.png";